export default "__VITE_ASSET__CirGauGk__"